<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? 'ADD NEW' : 'UPDATE' }} ITEM</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- Product Image -->
        <template v-if="dataImg">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive" />
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*" />
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
          </div>
        </template>

        <!-- NAME -->
        <vs-input label="Name (required)" v-model="name" class="mt-5 w-full" name="name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input
          label="SKU (optional)"
          v-model="identifier"
          v-validate.immediate="{ max: 100, regex: /^[a-zA-Z0-9-_]+$/ }"
          class="mt-5 w-full"
          name="identifier"
        />
        <span class="text-danger text-sm" v-show="errors.has('identifier')">{{ errors.first('identifier') }}</span>

        <div class="mt-5 vx-col w-full">
          <vs-input
            :disabled="this.role != 'staff'"
            data-vv-name="return_url"
            v-model="link.return_url"
            class="w-full"
            label="Return URL"
            data-vv-as="field"
            type="text"
          />
          <span v-show="errors.has('return_url')" class="text-danger">{{ errors.first('return_url') }}</span>
        </div>
        <span v-show="this.role != 'staff'" class="text-sm">
          Custom return urls require a paid plan.
          <router-link to="/pages/faq">
            <span v-on:click="closeSideBar()">Learn More</span>
          </router-link>
        </span>

        <div class="mt-5" v-if="model_identifier == 'hoverlay.core.3dModel.1.0'">
          <label class="vs-input--label">Select height of your model</label>
          <v-select :clearable="false" v-model="autoResize" label="text" class="w-full" :options="autoResizeOptions" />
        </div>
        <div
          v-if="
            model_identifier == 'hoverlay.art.WallArt.1.0' ||
              (model_identifier == 'hoverlay.core.3dModel.1.0' && autoResize.value)
          "
          class="flex -mx-2"
        >
          <div class="w-1/2 px-2">
            <vs-input
              v-validate="{ required: true, regex: /\d+(\.\d+)?$/ }"
              class="mt-5 w-full"
              label="Physical height"
              v-model="height"
              name="height"
            />
          </div>
          <br />
          <br />

          <div class="w-1/2 px-2">
            <!-- <ul class="margin-top mt-5 w-full leftx">
              <li>
                <vs-radio v-model="unit" vs-name="radios1" vs-value="cm">cm</vs-radio>
              </li>
              <li>
                <vs-radio v-model="unit" vs-name="radios1" vs-value="inches">inches</vs-radio>
              </li>
            </ul> -->
            <vs-select class="mt-5 w-full" v-model="unit" label="Unit">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in unitOptions" />
            </vs-select>
          </div>
        </div>
        <span class="text-danger text-sm" v-show="errors.has('item-height')">{{ errors.first('item-height') }}</span>
        <br />
        <div v-if="model_identifier == 'hoverlay.art.WallArt.1.0'" class="">
          <ul class="centerx">
            <li>
              <vs-checkbox v-model="virtualFrame">Virtual Frame</vs-checkbox>
            </li>
          </ul>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
  },
  data() {
    return {
      role: JSON.parse(localStorage.getItem('userInfo')).role,
      link: {},
      identifier: null,
      pid: null,
      name: '',
      height: '',
      abilities: '',
      model_identifier: '',
      dataImg: null,
      unit: 'cm',
      unitOptions: [
        { text: 'cm', value: 'cm' },
        { text: 'inches', value: 'inches' },
      ],
      virtualFrame: false,
      virtualFrameOptions: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
      ],
      autoResize: {
        text: 'Default',
        value: false,
      },
      autoResizeOptions: [
        {
          text: 'Custom',
          value: true,
        },
        {
          text: 'Default',
          value: false,
        },
      ],

      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    }
  },
  watch: {
    height() {
      if (this.autoResize.value) this.setHeight()
    },
    autoResize(autoResize) {
      if (!autoResize.value) {
        try {
          delete this.abilities['gltf_loader'].height
        } catch (e) {
          // console.log(e)
        }
        try {
          delete this.abilities['skin'].height
        } catch (e) {
          // console.log(e)
        }
      }
    },
    isSidebarActive(val) {
      this.unit = 'cm'

      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { abilities, pid, identifier, img, name, model_identifier } = JSON.parse(JSON.stringify(this.data))

        try {
          var link = this.$store.state.dataList.links.find(link => link.hobjects[0].pid == pid)
          this.link.return_url = link.return_url
          this.link.hobject_pid = pid
        } catch (e) {
          console.log(e)
        }

        let height = ''

        if (model_identifier == 'hoverlay.art.WallArt.1.0') {
          try {
            height = (parseFloat(JSON.parse(abilities).skin.height) * 100).toFixed(2)
          } catch (error) {
            console.log(error)
            height = 100
          }
          try {
            const virtualFrame = JSON.parse(abilities).frame
            if (virtualFrame !== undefined) this.virtualFrame = true
            else this.virtualFrame = false
          } catch (error) {
            this.virtualFrame = false
            console.log(error)
            height = 1
          }
        }

        this.identifier = identifier
        this.pid = pid
        this.name = name
        this.height = height
        this.abilities = JSON.parse(abilities)
        this.dataImg = img
        this.model_identifier = model_identifier

        this.link.layer_pid = JSON.parse(localStorage.getItem('layerInfo')).pid

        try {
          if (this.abilities.gltf_loader.height) {
            this.autoResize = {
              text: 'Custom',
              value: true,
            }
            this.height = (this.abilities.gltf_loader.height * 100).toFixed(2)
          } else {
            this.autoResize = {
              text: 'Default',
              value: false,
            }
            this.height = 50
          }
        } catch (e) {
          e
        }
      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return !this.errors.any() && this.name && this.pid > 0
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
  },
  methods: {
    initValues() {
      if (this.data.id) return
      this.pid = null
      this.name = null
      this.height = null
      this.abilities = null
      this.model_identifier = null
      this.link = {}
    },
    async submitData() {
      console.log('submitData')
      var result = await this.$validator.validateAll()
      console.log(this.$validator.errors)
      this.setHeight()

      if (result) {
        const hobjectLinkPayload = {
          pid: this.pid,
          identifier: this.identifier,
          name: this.name,
          abilities: JSON.stringify(this.abilities),
        }

        console.log('this.link')

        if (this.pid !== null) {
          try {
            await this.$store.dispatch('dataList/updateLink', this.link)
            console.log('hobjectLinkPayload', hobjectLinkPayload)
            await this.$store.dispatch('dataList/updateHobject', hobjectLinkPayload)
            this.$vs.loading.close()
            this.$vs.notify({ text: 'Artwork updated', color: 'success', icon: 'check_box' })
          } catch (e) {
            this.$vs.loading.close()
            console.error(e)
          }
        }

        this.$emit('closeSidebar')
        this.initValues()
      }
    },
    setHeight() {
      let computedHeight = null
      this.height = parseFloat(this.height)
      if (isNaN(this.height)) {
        if (this.model_identifier == 'hoverlay.art.WallArt.1.0') computedHeight = 1
      } else if (this.unit === 'inches') {
        computedHeight = this.height * 0.0254
      } else {
        computedHeight = this.height / 100
      }

      if (this.model_identifier == 'hoverlay.art.WallArt.1.0') {
        // Modify Framed attributes
        try {
          if (this.virtualFrame) this.abilities.frame = {}
          else delete this.abilities.frame
        } catch (error) {
          // console.log(error)
        }

        // Modify Height Value
        try {
          this.abilities.skin.height = computedHeight
        } catch (error) {
          // console.log(error)
        }
      }

      if (this.model_identifier == 'hoverlay.core.3dModel.1.0') {
        // Modify Height Value
        try {
          if (this.autoResize.value) this.abilities['gltf_loader'].height = computedHeight
          else delete this.abilities['gltf_loader'].height
          console.log(JSON.stringify(this.abilities))
        } catch (error) {
          console.log(error)
        }
      }
    },
    closeSideBar() {
      this.$emit('closeSidebar')
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.margin-top {
  margin-top: 25px;
}

.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
